export default function Grid({
  id = null,
  dom = {},
  endpoint = null,
  code = null,
  timestamp = + new Date(),
  isFetching = false
}) {
  this._id = id
  this._dom = dom
  this._endpoint = endpoint
  this._code = code
  this._timestamp = timestamp
  this._isFetching = isFetching
}

Grid.prototype.getId = function() {
  return this._id
}

Grid.prototype.setId = function(id) {
  this._id = id
}

Grid.prototype.getDom = function() {
  return this._dom
}

Grid.prototype.setDom = function(dom) {
  this._dom = dom
}

Grid.prototype.getEndpoint = function() {
  return this._endpoint
}

Grid.prototype.setEndpoint = function(endpoint) {
  this._endpoint = endpoint
}

Grid.prototype.getCode = function() {
  return this._code
}

Grid.prototype.setCode = function(code) {
  this._code = code
}

Grid.prototype.getTimestamp = function() {
  return this._timestamp
}

Grid.prototype.setTimestamp = function(timestamp) {
  this._timestamp = timestamp
}

Grid.prototype.getIsFetching = function() {
  return this._isFetching
}

Grid.prototype.setIsFetching = function(isFetching) {
  this._isFetching = isFetching
}



// WEBPACK FOOTER //
// ./src/entities/Grid.js